export const DELETED = 5;
export const CUSTOMER_REVIEW = 288;
export const CHECKOUT = 67239936;
export const CHECKOUT_WITH_DEPOSIT = 100794368;
export const CREDIT_APPROVAL = 1048576;
export const TRADE_IN_EVALUATION = 262144;
export const MANAGER_APPROVAL = 65536;
export const QUOTE_SOLD = 101843360;
export const QUOTE_DELIVERED = 2048;

export const ACTIVE_FLAGS = {
    ACTIVE: 0x0,
    INACTIVE: 0x1,
    LOST: 0x2,
    DELETED: 0x4,
};

export const ORIGIN_FLAGS = {
    LEAD: 0x10,
    CUSTOMER_WEB: 0x20,
};

export const OWNER_FLAGS = {
    CUSTOMER: 0x100,
    SALESPERSON: 0x200,
    MANAGER: 0x400,
    FNI: 0x800,
    ACCOUNTING: 0x1000,
};

export const PENDING_APPROVAL_FLAGS = {
    QUOTE_COMPLETION: 0x10000,
    OFFER_APPROVAL: 0x20000,
    TRADE_IN_EVALUATION: 0x40000,
    SALE_COMPLETION: 0x80000,
    CREDIT_APPROVAL: 0x100000,
    STOCK_MATCH: 0x200000,
    VEHICLE_DELIVERED_BOOKED: 0x400000,
    VEHICLE_TRIAL: 0x800000,
    ACCOUNTING_POST_VERIFIED: 0x1000000,
};

export const OFFER_FLAGS = {
    OFFER_WITH_DEPOSIT: 0x2000000,
    OFFER_CUSTOMER_WEB: 0x4000000,
};

export const STOCK_MATCH_FLAGS = {
    LOCATE: 0x8000000,
};

export const DELIVERY_FLAGS = {
    NO_FNI: 0x10000000,
};

export const DECLINED_FLAGS = {
    OFFER_DECLINED: 0x20000000,
    CREDIT_DECLINED: 0x40000000,
    VEHICLE_TRIAL_RETURNED: 0x80000000,
};

export const APPROVED_COMPLETED_FLAGS = {
    QUOTE_COMPLETED: 0x100000000,
    OFFER_APPROVED_SOLD: 0x200000000,
    TRADE_IN_EVALUATION_COMPLETED: 0x400000000,
    SALE_COMPLETED: 0x800000000,
    CREDIT_APPROVED: 0x1000000000,
    STOCK_MATCHED: 0x2000000000,
    VEHICLE_DELIVERED: 0x4000000000,
    VEHICLE_TRIAL_ENDED: 0x8000000000,
    ACCOUNTING_POST_POSTED: 0x10000000000,
};

export default {
    DELETED,
    CUSTOMER_REVIEW,
    CHECKOUT,
    CHECKOUT_WITH_DEPOSIT,
    CREDIT_APPROVAL,
    TRADE_IN_EVALUATION,
    MANAGER_APPROVAL,
    ACTIVE_FLAGS,
    ORIGIN_FLAGS,
    OWNER_FLAGS,
    PENDING_APPROVAL_FLAGS,
    OFFER_FLAGS,
    STOCK_MATCH_FLAGS,
    DELIVERY_FLAGS,
    DECLINED_FLAGS,
    APPROVED_COMPLETED_FLAGS,
    QUOTE_SOLD,
    QUOTE_DELIVERED,
};
